export const calculateResponsiveSize = (px) => `${px / 12.8}vw`
export const calculateResponsiveSizeH = (px) => `${px / 12.8}vw`
